import React from 'react';
import { render } from 'react-dom';
// jl-design-system
import DataActionManager from 'jl-design-system/components/data-action-manager/DataActionManager';
// lodash
import get from 'lodash/get';
import includes from 'lodash/includes';
// redux
import { dataAction } from './redux/actions/data-action-link/dataActionLinkActions';
import mobileAppsActions from './redux/actions/mobileApps/mobileAppsActions';
// utils
import configureStore from './redux/configureStore';
import { URL_CONFIGURATION, URL_FEATURES } from './constants/endpointConstants';
import appConstants from './constants/appConstants';
import routeConstants from './constants/routeConstants';
import createBrowserHistory from './utils/history/history';
import api from './utils/api/api';
import { setStorageItem } from './utils/storage/storage';
import { initLogging } from './utils/logging/logging-utils';
import unionWithDevFeatures from './utils/features/feature-utils';
// components
import Root from './Root';


export const reactDOM = {
  render,
};

const mount = document.getElementById('root');

function onRender(store) {
  // initialise DataActionManager action
  DataActionManager.setDataAction((...args) => store.dispatch(dataAction(...args)));

  store.dispatch(initLogging());
}

export function init(initialState = {}) {

  const history = createBrowserHistory();

  const { store, persistor } = configureStore(history, initialState);

  // Set up Apps actions
  window.appsActions = mobileAppsActions(store);

  const root = <Root history={history} persistor={persistor} store={store} />;
  reactDOM.render(root, mount, () => { onRender(store); });

  if (module.hot) {
    module.hot.accept('./Root', () => {
      const NewRoot = require('./Root').default; // eslint-disable-line global-require
      const root = <NewRoot history={history} persistor={persistor} store={store} />;
      reactDOM.render(root, mount, () => { onRender(store); });
    });
  }
}

function getFeatures() {
  return api({
    path: URL_FEATURES,
    config: { method: 'GET' },
  }).then((response) => {
    const bffFeatures = get(response, 'features', []);
    return unionWithDevFeatures(bffFeatures);
  }).catch(() => []);
}

const skipGetFeaturesCallOnPaths = [
  routeConstants.LOGIN,
  routeConstants.PACT_HANDOVER,
  routeConstants.WEB_HANDOVER,
  routeConstants.APPS_GUEST_HANDOVER,
  routeConstants.APPS_AUTHENTICATED_HANDOVER,
  routeConstants.CALLBACK_LOGIN_AUTHENTICATED,
  routeConstants.CALLBACK_LOGIN_GUEST,
  routeConstants.CALLBACK_ORDER_CLAIM,
];

export default function initApp() {
  return api({
    path: URL_CONFIGURATION,
    config: { method: 'GET' },
  }).then(async (response) => {
    const countries = get(response, 'countries', []);
    const applePayConfiguration = get(response, 'applePayConfiguration', {});
    const frontendKeys = get(response, 'frontendKeys', 'googleMapsApiKey');
    const sessionWarningAfterTime = get(response, 'sessionWarningAfterTime');
    const clickAndCollectCutOffWindowInMinutes = get(response, 'clickAndCollectCutOffWindowInMinutes');
    const creditCardTypes = get(response, 'creditCardTypes', []);
    const googlePayConfiguration = get(response, 'googlePayConfiguration', {});

    setStorageItem({
      key: appConstants.COUNTRIES,
      value: JSON.stringify(countries),
      local: false,
      checkForPermission: false,
    });

    const features = includes(skipGetFeaturesCallOnPaths, window.location.pathname)
      ? []
      : await getFeatures();

    const initialState = {
      config: {
        countries: [...countries],
        creditCardTypes,
        features,
        applePayConfiguration,
        frontendKeys: { ...frontendKeys },
        sessionWarningAfterTime,
        clickAndCollectCutOffWindowInMinutes,
        googlePayConfiguration,
      },
    };

    init(initialState);
  });

}

initApp();
